import React from 'react';
import IDocumentFile from '../interfaces/IDocumentFile';
import { useMediaQuery, useTheme } from '@mui/material';
import VDocumentFilesTableDesktopV2 from './VDocumentFilesTableDesktopV2';
import VDocumentFilesTableMobileV2 from './VDocumentFilesTableMobileV2';

type VDocumentFilesTableProps = {
	documents: IDocumentFile[];
	displayColumns?: string[];
	hideFooter?: boolean;
};

const VDocumentFilesTable = (props: VDocumentFilesTableProps) => {
	const { documents, displayColumns, hideFooter } = props;

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<>
			{!isMobile ? (
				<VDocumentFilesTableDesktopV2
					documents={documents}
					hideFooter={hideFooter ?? false}
					displayColumns={displayColumns}
				/>
			) : (
				<VDocumentFilesTableMobileV2 documents={documents} displayColumns={displayColumns} />
			)}
		</>
	);
};

export default VDocumentFilesTable;
